<nz-row [nzGutter]="[5, 5]">
  <nz-col
    *ngIf="successUploadItemsCount$ | async"
    [nzXs]="grid.xs"
    [nzSm]="grid.sm"
    [nzMd]="grid.md"
    [nzLg]="grid.lg"
  >
    <app-lot-add-photo-uploading-list-item-add
      [style.height.px]="itemHeightPx"
      (uploadingItems)="pushUploadingItems($event, 'forward')"
    ></app-lot-add-photo-uploading-list-item-add>
  </nz-col>

  <nz-col
    *ngFor="
      let item of validItems$ | async;
      first as isAuctionList;
      trackBy: trackByUploadingListItem
    "
    [nzXs]="grid.xs"
    [nzSm]="grid.sm"
    [nzMd]="grid.md"
    [nzLg]="grid.lg"
  >
    <app-lot-add-photo-uploading-list-item
      [style.height.px]="itemHeightPx"
      [uploadingListItem]="item"
      [isAuctionList]="isAuctionList && !noAuctionList"
      (remove)="removeUploadingItem($event)"
      (openPreview)="openPreview($event)"
      (setAsAuctionList)="setUploadingItemAsAuctionList($event)"
    ></app-lot-add-photo-uploading-list-item>
  </nz-col>

  <nz-col
    *ngFor="let item of errorUploadItems$ | async; trackBy: trackByUploadingListItem"
    [nzXs]="grid.xs"
    [nzSm]="grid.sm"
    [nzMd]="grid.md"
    [nzLg]="grid.lg"
  >
    <app-lot-add-photo-uploading-list-item
      [style.height.px]="itemHeightPx"
      [uploadingListItem]="item"
    ></app-lot-add-photo-uploading-list-item>
  </nz-col>

  <nz-col [nzXs]="grid.xs" [nzSm]="grid.sm" [nzMd]="grid.md" [nzLg]="grid.lg">
    <app-lot-add-photo-uploading-list-item-add
      [style.height.px]="itemHeightPx"
      (uploadingItems)="pushUploadingItems($event, 'end')"
    ></app-lot-add-photo-uploading-list-item-add>
  </nz-col>
</nz-row>
